"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _focusTrapReact = _interopRequireDefault(require("focus-trap-react"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styled = require("./styled");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const Modal = _ref => {
  let {
    active,
    children,
    danger,
    height = 'auto',
    focusTrap = true,
    loading,
    onToggle = () => null,
    padding = '20px',
    width
  } = _ref;
  const onKeyDown = _ref2 => {
    let {
      key
    } = _ref2;
    if (key === 'Escape') {
      onToggle();
    }
  };
  const backdropProps = {
    onKeyDown
  };
  const commonProps = {
    active
  };
  const containerProps = {
    danger,
    height,
    padding,
    role: 'dialog',
    width
  };
  if (active) {
    if (loading || !focusTrap) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.Backdrop, _objectSpread(_objectSpread(_objectSpread({}, commonProps), backdropProps), {}, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.Container, _objectSpread(_objectSpread({}, containerProps), {}, {
          children: loading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
            active: true
          }) : children
        }))
      }));
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_focusTrapReact.default, _objectSpread(_objectSpread({}, commonProps), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.Backdrop, _objectSpread(_objectSpread(_objectSpread({}, commonProps), backdropProps), {}, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.Container, _objectSpread(_objectSpread({}, containerProps), {}, {
          children: children
        }))
      }))
    }));
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.Backdrop, _objectSpread(_objectSpread({}, commonProps), backdropProps));
};
Modal.propTypes = {
  active: _propTypes.default.bool,
  children: _propTypes.default.any,
  danger: _propTypes.default.bool,
  height: _propTypes.default.string,
  focusTrap: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  onToggle: _propTypes.default.func,
  padding: _propTypes.default.string,
  width: _propTypes.default.string
};
var _default = exports.default = Modal;